import { FC } from "react"
import Icon from "../../Fondations/Icons/Icon"
import style from "./Badge.module.css"

type BadgeSmallVariants =
  | "badge-small-error"
  | "badge-small-information"
  | "badge-small-success"
  | "badge-small-warning"
type BadgeBigVariants = "badge-big-error" | "badge-big-information" | "badge-big-success" | "badge-big-warning"
export type BadgeVariants = BadgeSmallVariants | BadgeBigVariants

type BadgeSize = "xs" | "m"
type BadgeIconName = "exclamation" | "info" | "checkThick"

type BadgeVariantProps = {
  status: BadgeIconName
  size: BadgeSize
}
const badgeVariantToProps: Record<BadgeVariants, BadgeVariantProps> = Object.freeze({
  "badge-small-error": { status: "exclamation", size: "xs" },
  "badge-small-information": { status: "info", size: "xs" },
  "badge-small-success": { status: "checkThick", size: "xs" },
  "badge-small-warning": { status: "exclamation", size: "xs" },
  "badge-big-error": { status: "exclamation", size: "m" },
  "badge-big-information": { status: "info", size: "m" },
  "badge-big-success": { status: "checkThick", size: "m" },
  "badge-big-warning": { status: "exclamation", size: "m" },
})

type BadgeProps = {
  variant: BadgeVariants
}

export const Badge: FC<BadgeProps> = ({ variant }) => {
  return (
    <div className={style[variant]}>
      <Icon
        name={badgeVariantToProps[variant].status}
        size={badgeVariantToProps[variant].size}
      />
    </div>
  )
}
